// extracted by mini-css-extract-plugin
export default {"abandonPopin__title":"styles_abandonPopin__title__EqkNY","abandonPopin__footer":"styles_abandonPopin__footer__KtpE7","abandonPopin__cta":"styles_abandonPopin__cta__WWvm3"};